import { Outlet } from "react-router-dom";

export const AuthLayout = () => {
	return (
		<div className="w-[100vw] h-[100vh] relative" id="portal-auth">
			<Outlet />
			<footer className="w-full border-t border-border-soft bg-white flex items-center justify-center gap-6 h-[50px] flex-shrink-0">
				<p className="text-primary-gray  flex items-center w-full  justify-center font-thin text-sm">
					Copyright © 2026 MACONIA GmbH. All rights reserved.
				</p>
			</footer>
		</div>
	);
};
